// // src/api/events.js
// import { get } from "../lib/http";
// import { API } from "../config/api";

// /* ---------- helpers ---------- */
// const inr = (n) =>
//   typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n || "—";

// const fmtDateTime = (iso) => {
//   if (!iso) return "";
//   const d = new Date(iso);
//   const day = d.toLocaleDateString("en-GB", { weekday: "short" });
//   const date = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
//   const time = d.toLocaleTimeString("en-GB", { hour: "numeric", minute: "2-digit", hour12: true });
//   return `${day}, ${date} • ${time}`;
// };

// /** Backend event -> EventCard shape */
// export function mapEventToCard(e) {
//   // min price from ticketCategories
//   let minPrice;
//   if (Array.isArray(e?.ticketCategories) && e.ticketCategories.length) {
//     const prices = e.ticketCategories
//       .map((t) => Number(t?.price))
//       .filter((n) => !Number.isNaN(n));
//     if (prices.length) minPrice = Math.min(...prices);
//   }

//   return {
//     id: e?._id || e?.id,
//     title: e?.name || e?.title || "Untitled",
//     category: e?.category || "Other",
//     location:
//       e?.venue?.name && e?.venue?.city
//         ? `${e.venue.name}, ${e.venue.city}`
//         : (e?.venue?.name || e?.venue?.city || ""),
//     date: fmtDateTime(e?.date || e?.showtimes?.[0]?.startTime),
//     time: "",
//     image: e?.imageUrl || e?.landsacpImage?.[0] || "",
//     tag: Array.isArray(e?.tags) && e.tags.length ? String(e.tags[0]) : "",
//     status: e?.status?.toLowerCase?.(),   // e.g. "upcoming"
//     verified: !!e?.isVerified,
//     price: minPrice,
//     priceText: minPrice ? inr(minPrice) : "—",
//     __raw: e, // raw keep (for later detail page)
//   };
// }

// /** Raw list */
// export async function fetchAllEventsRaw() {
//   const res = await get(API.events.getEvent, {
//     headers: { "Content-Type": "application/json" },
//   });
//   // expect: { events: [...] }
//   return Array.isArray(res?.events) ? res.events : [];
// }

// /** Mapped list */
// export async function fetchAllEvents() {
//   const list = await fetchAllEventsRaw();
//   return list.map(mapEventToCard);
// }

// export async function apiTrending(city = "Mumbai", limit = 9) {
//   const list = await fetchAllEvents();
//   const trending = list.filter((e) =>
//     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "trending")
//   );
//   const filtered = trending.length ? trending : list;
//   // अगर city filter चाहिए तो
//   const cityFiltered = filtered.filter((e) =>
//     (e?.venue?.city || "").toLowerCase().includes(city.toLowerCase())
//   );
//   return (cityFiltered.length ? cityFiltered : filtered).slice(0, limit);
// }

// // View All page पर सारे Trending
// export async function apiTrendingAll(city = "Mumbai") {
//   const list = await fetchAllEvents();
//   const trending = list.filter((e) =>
//     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "trending")
//   );
//   const filtered = trending.length ? trending : list;
//   return filtered.filter((e) =>
//     (e?.venue?.city || "").toLowerCase().includes(city.toLowerCase())
//   );
// }

// /** Featured = tag includes "Featured" (fallback: first N) */
// // export async function apiFeatured(limit = 9) {
// //   const list = await fetchAllEvents();
// //   const featured = list.filter((e) =>
// //     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "featured")
// //   );
// //   return (featured.length ? featured : list).slice(0, limit);
// // }

// /** Trending by city or tag "Trending" (fallback all) */
// // export async function apiTrending(city = "Mumbai", limit = 8) {
// //   const list = await fetchAllEvents();
// //   const trending = list.filter((e) =>
// //     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "trending")
// //   );
// //   const byCity = list.filter((e) =>
// //     String(e?.__raw?.venue?.city || "")
// //       .toLowerCase()
// //       .includes(String(city).toLowerCase())
// //   );
// //   const base = trending.length ? trending : (byCity.length ? byCity : list);
// //   return base.slice(0, limit);
// // }

// /** This weekend = next 7 days */
// export async function apiWeekend(limit = 12) {
//   const list = await fetchAllEvents();
//   const now = new Date();
//   const next7 = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);

//   const within = list.filter((e) => {
//     const dt = new Date(e?.__raw?.date || e?.__raw?.showtimes?.[0]?.startTime);
//     return !isNaN(+dt) && dt >= now && dt <= next7;
//   });

//   return (within.length ? within : list).slice(0, limit);
// }

// // same file where mapEventToCard, fetchAllEvents हैं

// export async function apiFeatured(limit = 9) {
//   const list = await fetchAllEvents();
//   const featured = list.filter((e) =>
//     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "featured")
//   );
//   return (featured.length ? featured : list).slice(0, limit);
// }

// // Add this to fetch ALL featured without slice for the View All page
// export async function apiFeaturedAll() {
//   const list = await fetchAllEvents();
//   const featured = list.filter((e) =>
//     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "featured")
//   );
//   return featured.length ? featured : list; // fallback: all events
// }


// /* optional: static (cities/testimonials) ko yahan se mat export karo, unhe
//    kisi alag file (e.g. src/api/static.js) me rakho. */



// // // ----- Mock APIs (replace with your endpoints later) -----
//   // export async function apiFeatured() {
//   //   return [
//   //     {
//   //       id: "f1",
//   //       title: "Live Garba Night: Dandiya Celebration",
//   //       location: "Nesco Grounds, Goregaon (E)",
//   //       date: "12 Nov · 4:00 PM",
//   //       price: 1499,
//   //       tag: "Featured",
//   //       image:
//   //         "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=1600&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "f2",
//   //       title: "Mumbai Food Festival",
//   //       location: "Juhu Beach, Mumbai",
//   //       date: "18–20 Nov · 11:00 AM",
//   //       price: 299,
//   //       tag: "New",
//   //       image:
//   //         "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=1600&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "f3",
//   //       title: "Kathak & Odissi: Classical Dance",
//   //       location: "Royal Opera House, Mumbai",
//   //       date: "26 Nov · 10:00 AM",
//   //       price: 599,
//   //       tag: "Hot",
//   //       image:
//   //         "https://images.unsplash.com/photo-1515405295579-ba7b45403062?q=80&w=1600&auto=format&fit=crop",
//   //     },
//   //   ];
//   // }

//   // export async function apiTrending(city = "Mumbai") {
//   //   return [
//   //     {
//   //       id: "t1",
//   //       title: "Sunburn Arena ft. DJ Snake",
//   //       location: "MMRDA Grounds, BKC",
//   //       date: "12 Nov · 4:00 PM",
//   //       price: 1499,
//   //       image:
//   //         "https://images.unsplash.com/photo-1506157786151-b8491531f063?q=80&w=1600&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "t2",
//   //       title: "Mumbai Food Festival",
//   //       location: "Juhu Beach, Mumbai",
//   //       date: "18–20 Nov · 11:00 AM",
//   //       price: 299,
//   //       image:
//   //         "https://images.unsplash.com/photo-1532635109-0463b9c03b05?q=80&w=1600&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "t3",
//   //       title: "Comic Con India",
//   //       location: "Bombay Exhibition Center",
//   //       date: "25–26 Nov · 10:00 AM",
//   //       price: 599,
//   //       image:
//   //         "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?q=80&w=1600&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "t4",
//   //       title: "Mumbai Marathon 2025",
//   //       location: "Starting: Azad Maidan",
//   //       date: "3 Dec · 5:30 AM",
//   //       price: 1200,
//   //       image:
//   //         "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=1600&auto=format&fit=crop",
//   //     },
//   //   ];
//   // }

//   // export async function apiWeekend() {
//   //   return [
//   //     {
//   //       id: "w1",
//   //       title: "Contemporary Art Exhibition",
//   //       location: "Jehangir Art Gallery",
//   //       date: "Sat–Sun · 10:00 AM",
//   //       price: 200,
//   //       image:
//   //         "https://images.unsplash.com/photo-1536924940846-227afb31e2a5?q=80&w=1400&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "w2",
//   //       title: "Organic Farmers Market",
//   //       location: "D'monte Park, Bandra",
//   //       date: "Sun · 8:00 AM",
//   //       price: 0,
//   //       image:
//   //         "https://images.unsplash.com/photo-1556767576-bac2519abf35?q=80&w=1400&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "w3",
//   //       title: "Bollywood Dance Workshop",
//   //       location: "Studio Pulse, Andheri",
//   //       date: "Sat · 4:00 PM",
//   //       price: 499,
//   //       image:
//   //         "https://images.unsplash.com/photo-1520975693416-35a79454b9f3?q=80&w=1400&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "w4",
//   //       title: "Open Mic Comedy Night",
//   //       location: "Cuckoo Club, Bandra",
//   //       date: "Sat · 8:30 PM",
//   //       price: 299,
//   //       image:
//   //         "https://images.unsplash.com/photo-1541233349642-6e425fe6190e?q=80&w=1400&auto=format&fit=crop",
//   //     },
//   //     {
//   //       id: "w5",
//   //       title: "Heritage Walk Tour",
//   //       location: "Gateway of India",
//   //       date: "Sun · 7:00 AM",
//   //       price: 350,
//   //       image:
//   //         "https://images.unsplash.com/photo-1578926287825-5a88a0a9d1ec?q=80&w=1400&auto=format&fit=crop",
//   //     },
//   //   ];
//   // }

//   // // export const cities = [
//   // //   { name: "Mumbai", img: "https://images.unsplash.com/photo-1501105444513-41a0a28a3889?q=80&w=1600&auto=format&fit=crop" },
//   // //   { name: "Delhi", img: "https://images.unsplash.com/photo-1582106151695-5f2f7f53f29a?q=80&w=1600&auto=format&fit=crop" },
//   // //   { name: "Bengaluru", img: "https://images.unsplash.com/photo-1604841319867-8f73d5a92047?q=80&w=1600&auto=format&fit=crop" },
//   // //   { name: "Pune", img: "https://images.unsplash.com/photo-1602491674277-2c9d2b6ee367?q=80&w=1600&auto=format&fit=crop" },
//   // //   { name: "Hyderabad", img: "https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=1600&auto=format&fit=crop" }
//   // // ];

//   // // Cities + Testimonials (used on Home)
//   export const cities = [
//     {
//       name: "Mumbai",
//       img: "https://picsum.photos/seed/mumbai/800/600",
//     },
//     {
//       name: "Delhi",
//       img: "https://picsum.photos/seed/delhi/800/600",
//     },
//     {
//       name: "Bengaluru",
//       img: "https://picsum.photos/seed/bengaluru/800/600",
//     },
//     {
//       name: "Pune",
//       img: "https://picsum.photos/seed/pune/800/600",
//     },
//     {
//       name: "Hyderabad",
//       img: "https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=1600&auto=format&fit=crop",
//     },
//   ];

//   export const testimonials = [
//     {
//       name: "Ritesh Gupta",
//       handle: "@riteshg",
//       text:
//         "Super smooth booking and great seats. Loved the reminder and QR ticket!",
//       avatar: "https://i.pravatar.cc/80?img=12",
//     },
//     {
//       name: "Srishti Jain",
//       handle: "@srishti.j",
//       text:
//         "The app is clean and fast. Found events near me and got a sweet discount.",
//       avatar: "https://i.pravatar.cc/80?img=5",
//     },
//     {
//       name: "Sameer Patil",
//       handle: "@iamsameer",
//       text: "Best place to discover gigs in the city. 10/10 would recommend.",
//       avatar: "https://i.pravatar.cc/80?img=33",
//     },
//   ];


import { get } from "../lib/http";
import { API, BASE_URL } from "../config/api";

/** Relative upload paths → absolute (fixes broken card images on localhost). */
export function absMediaUrl(u) {
  if (!u || typeof u !== "string") return null;
  const s = u.trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  const origin = BASE_URL.replace(/\/+$/, "");
  return s.startsWith("/") ? `${origin}${s}` : `${origin}/${s}`;
}

/** Portrait poster first (Premium card, event tiles) */
export function resolveEventPosterUrl(event) {
  const portrait = absMediaUrl(event?.imageUrl);
  if (portrait) return portrait;
  const landscape = Array.isArray(event?.landsacpImage)
    ? event.landsacpImage.find(Boolean)
    : event?.landsacpImage;
  return absMediaUrl(landscape) || absMediaUrl(event?.image) || null;
}

let lastController = null;


/* ---------- helpers ---------- */
const inr = (n) =>
  typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n || "—";

// const fmtDateTime = (iso) => {
//   if (!iso) return "";
//   const d = new Date(iso);
//   const day = d.toLocaleDateString("en-GB", { weekday: "short" });
//   const date = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
//   const time = d.toLocaleTimeString("en-GB", { hour: "numeric", minute: "2-digit", hour12: true });
//   return `${day}, ${date} • ${time}`;
// };

// 👇 Drop-in replacement
const fmtDateTime = (iso) => {
  if (!iso) return "";

  // If the string ends with Z, assume it was meant to be IST (local) and not UTC.
  // Convert "...Z" -> "...+05:30" so we interpret it as IST.
  const asIST = /Z$/i.test(iso) ? iso.replace(/Z$/i, "+05:30") : iso;

  const d = new Date(asIST);
  const day = d.toLocaleDateString("en-GB", {
    weekday: "short",
    timeZone: "Asia/Kolkata",
  });
  const date = d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    timeZone: "Asia/Kolkata",
  });
  const time = d.toLocaleTimeString("en-GB", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });

  return `${day}, ${date} • ${time}`;
};

function toISTDateInput(iso) {
  if (!iso) return null;
  const asIST = /Z$/i.test(String(iso)) ? String(iso).replace(/Z$/i, "+05:30") : String(iso);
  const d = new Date(asIST);
  return Number.isNaN(d.getTime()) ? null : d;
}

function collectShowtimeDaysIST(event) {
  const slots = Array.isArray(event?.showtimes) ? event.showtimes : [];
  const byDay = new Map();

  for (const s of slots) {
    const d = toISTDateInput(s?.startTime);
    if (!d) continue;
    const key = d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    if (byDay.has(key)) continue;
    byDay.set(key, {
      dayLabel: d.toLocaleDateString("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        timeZone: "Asia/Kolkata",
      }),
      timeLabel: d.toLocaleTimeString("en-GB", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      }),
    });
  }

  return [...byDay.values()];
}

/** Structured schedule for Premium / detail UI */
export function getEventScheduleParts(event) {
  const days = collectShowtimeDaysIST(event);
  if (days.length > 1) {
    const times = [...new Set(days.map((x) => x.timeLabel))];
    return {
      multiDay: true,
      dates: days.map((x) => x.dayLabel),
      time: times.length === 1 ? times[0] : null,
      slots: times.length > 1 ? days : null,
      full: formatEventScheduleLabel(event),
    };
  }
  if (days.length === 1) {
    return {
      multiDay: false,
      dates: [days[0].dayLabel],
      time: days[0].timeLabel,
      slots: null,
      full: `${days[0].dayLabel} • ${days[0].timeLabel}`,
    };
  }
  const full = fmtDateTime(event?.date || event?.showtimes?.[0]?.startTime);
  return { multiDay: false, dates: [], time: null, slots: null, full };
}

/** Card / list: all showtime days (e.g. Sat, 30 May & Sun, 31 May • 5:30 pm) */
export function formatEventScheduleLabel(event) {
  const days = collectShowtimeDaysIST(event);
  const slots = Array.isArray(event?.showtimes) ? event.showtimes : [];

  if (days.length > 1) {
    const dayStr = days.map((x) => x.dayLabel).join(" & ");
    const times = [...new Set(days.map((x) => x.timeLabel))];
    return `${dayStr} • ${times.length === 1 ? times[0] : days.map((x) => x.timeLabel).join(" · ")}`;
  }
  if (days.length === 1) {
    return `${days[0].dayLabel} • ${days[0].timeLabel}`;
  }

  return fmtDateTime(event?.date || slots[0]?.startTime);
}

/** Backend event -> EventCard shape */
// export function mapEventToCard(e) {
//   // min price from ticketCategories
//   let minPrice;
//   if (Array.isArray(e?.ticketCategories) && e.ticketCategories.length) {
//     const prices = e.ticketCategories
//       .map((t) => Number(t?.price))
//       .filter((n) => !Number.isNaN(n));
//     if (prices.length) minPrice = Math.min(...prices);
//   }
//   return {
//     id: e?._id || e?.id,
//     title: e?.name || e?.title || "Untitled",
//     category: e?.category || "Other",
//     location:
//       e?.venue?.name && e?.venue?.city
//         ? `${e.venue.name}, ${e.venue.city}`
//         : (e?.venue?.name || e?.venue?.city || ""),
//     date: fmtDateTime(e?.date || e?.showtimes?.[0]?.startTime),
//     time: "",
//     // ⚠️ never pass "" to <img src>; use null if missing
//     image: e?.imageUrl || e?.landsacpImage?.[0] || null,
//     tag: Array.isArray(e?.tags) && e.tags.length ? String(e.tags[0]) : "",
//     status: e?.status?.toLowerCase?.(),   // e.g. "upcoming"
//     verified: !!e?.isVerified,
//     price: minPrice,
//     priceText: minPrice ? inr(minPrice) : "—",
//     __raw: e, // keep raw for detail/trending filters
//   };
// }

export function mapEventToCard(e) {
  let minPrice;

  if (Array.isArray(e?.ticketCategories) && e.ticketCategories.length) {
    // ✅ Filter tickets that are available and have a valid price
    const prices = e.ticketCategories
      .filter((t) => t?.isTicketAvailable !== false) // only include available tickets
      .map((t) => Number(t?.price))
      .filter((n) => !Number.isNaN(n));

    if (prices.length) {
      minPrice = Math.min(...prices);
    }
  }
  return {
    id: e?._id || e?.id,
    title: e?.name || e?.title || "Untitled",
    category: e?.category || "Other",
    location:
      e?.venue?.name && e?.venue?.city
        ? `${e.venue.name}, ${e.venue.city}`
        : (e?.venue?.name || e?.venue?.city || ""),
    date: formatEventScheduleLabel(e),
    time: "",
    image: absMediaUrl(e?.imageUrl || e?.landsacpImage?.[0]) || null,
    tag: Array.isArray(e?.tags) && e.tags.length ? String(e.tags[0]) : "",
    status: e?.status,
    verified: !!e?.isVerified,
    price: minPrice,
    priceText: minPrice ? inr(minPrice) : "—",
    __raw: e,
  };
}

/** Raw list */
export async function fetchAllEventsRaw() {
  const res = await get(API.events.getEvent, {
    headers: { "Content-Type": "application/json" },
  });
  // expect: { events: [...] }
  return Array.isArray(res?.events) ? res.events : [];
}

/** Mapped list */
export async function fetchAllEvents() {
  const list = await fetchAllEventsRaw();
  return list.map(mapEventToCard);
}

/** Filter by category via query param (?category=) */
export async function fetchEventsByCategory(categoryValue, { limit } = {}) {
  // all → return everything
  if (!categoryValue || String(categoryValue).toLowerCase() === "all") {
    const list = await fetchAllEvents();
    return typeof limit === "number" ? list.slice(0, limit) : list;
  }

  const params = new URLSearchParams();
  // change the key if your backend expects `categoryId` instead
  params.set("category", String(categoryValue));

  const res = await get(`${API.events.getEvent}?${params.toString()}`, {
    headers: { "Content-Type": "application/json" },
  });

  const raw = Array.isArray(res?.events) ? res.events : [];
  let mapped = raw.map(mapEventToCard);

  // Client-side fallback (if server didn't filter)
  if (!mapped.length) {
    const all = await fetchAllEvents();
    mapped = all.filter(
      (e) =>
        String(e?.__raw?.category || e?.category || "")
          .toLowerCase()
          .trim() === String(categoryValue).toLowerCase().trim()
    );
  }

  return typeof limit === "number" ? mapped.slice(0, limit) : mapped;
}

export async function apiTrending(city = "all", limit = 9) {
  const list = await fetchAllEvents();
  const trending = list.filter((e) =>
    (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "trending")
  );
  const filtered = trending.length ? trending : list;
  // ✅ fix: use raw city (mapped card doesn't have e.venue)
  const cityFiltered = filtered.filter((e) =>
    String(e?.__raw?.venue?.city || "").toLowerCase().includes(city.toLowerCase())
  );
  return (cityFiltered.length ? cityFiltered : filtered).slice(0, limit);
}

export async function apiTrendingAll(city = "all") {
  const list = await fetchAllEvents();
  const trending = list.filter((e) =>
    (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "trending")
  );
  const filtered = trending.length ? trending : list;
  return filtered.filter((e) =>
    String(e?.__raw?.venue?.city || "").toLowerCase().includes(city.toLowerCase())
  );
}

/** This weekend = next 7 days */
// export async function apiWeekend(limit = 12) {
//   const list = await fetchAllEvents();
//   const now = new Date();
//   const next7 = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
//   debugger
//   const within = list.filter((e) => {
//     const dt = new Date(e?.__raw?.date || e?.__raw?.showtimes?.[0]?.startTime);
//     return !isNaN(+dt) && dt >= now && dt <= next7;
//   });

//   return (within.length ? within : list).slice(0, limit);
// }

// status can be "Past", "Upcoming", "Live", etc.
// Case-insensitive, trims whitespace. Falls back to full list if no matches.
export async function apiWeekend(limit = 12, status = "") {
  const list = await fetchAllEvents();

  // const norm = String(status || "").trim().toLowerCase();
  const filtered =  list.filter((e) => e?.status  === 'Past')
  return filtered.slice(0, limit);
}


// export async function apiFeatured(limit = 9) {
//   const list = await fetchAllEvents();
//   const featured = list.filter((e) =>
//     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "featured")
//   );
//   return (featured.length ? featured : list).slice(0, limit);
// }

export async function apiFeatured(limit = 9) {
  const list = await fetchAllEvents();
  const live = list.filter(
    (e) => String(e?.status || "").toLowerCase() === "live"
  );

  const primary = live.slice(0, limit);

  if (primary.length < limit) {
    const need = limit - primary.length;
    const filler = list.filter(
      (e) =>
        !primary.includes(e) && String(e?.status || "").toLowerCase() !== "past"
    );
    return [...primary, ...filler.slice(0, need)];
  }

  return primary;
}


// View All Featured
// export async function apiFeaturedAll() {
//   const list = await fetchAllEvents();
//   const featured = list.filter((e) =>
//     (e.__raw?.tags || []).some((t) => String(t).toLowerCase() === "featured")
//   );
//   return featured.length ? featured : list;
// }

// export async function apiFeaturedAll(filters = {}) {
//   // Build query string safely (skip empty values)
//   const qs = new URLSearchParams();
//   for (const [k, v] of Object.entries(filters)) {
//     if (v !== "" && v !== undefined && v !== null) qs.append(k, v);
//   }

//   // If your API requires tokens, include them like you did in banners API:
//   const token = JSON.parse(localStorage.getItem("bb_user"))?.token || "";
//   const url = `${API.events.getEvent}${qs.toString() ? `?${qs.toString()}` : ""}`;

//   const res = await get(url, {
//     headers: {
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//     },
//   });
//   // Normalize response shape:
//   // - Some endpoints return { data: [...] }
//   // - Others may return an array directly
//   // - If your backend returns paginate/meta, we still extract .data
//   const data = Array.isArray(res) ? res : (res?.events ?? []);
//   return data;
// }

export async function apiFeaturedAll(filters = {}) {
  // cancel previous request if any
  if (lastController) lastController.abort();
  lastController = new AbortController();

  // build query string from non-empty values
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== "" && v !== undefined && v !== null) qs.append(k, v);
  }

  // If backend needs a flag for featured, uncomment:
  // qs.append("isFeatured", "true");

  const token = JSON.parse(localStorage.getItem("bb_user"))?.token || "";
  const url = `${API.events.getEvent}${qs.toString() ? `?${qs.toString()}` : ""}`;

  // helpful debug
  // console.log("[apiFeaturedAll] URL =>", url);

  const res = await get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    signal: lastController.signal,
  });

  // normalize:
  // - some APIs return array directly
  // - many return { data: [...] }
  const data = Array.isArray(res) ? res : (res?.events ?? []);
  return data;
}


/* Cities + Testimonials (kept as-is) */
export async function fetchCities() {
  const res = await get(API.category.Cities, {
    headers: { "Content-Type": "application/json" },
  });
  // accept either { Cities: [...] } or { cities: [...] }
  const raw = Array.isArray(res?.Cities) ? res.Cities : (Array.isArray(res?.cities) ? res.cities : []);
  return raw.map((c, i) => {
    if (typeof c === "string") return { name: c, value: c, img: "" };
    const name = c.name || c.title || c.city || `City ${i + 1}`;
    const value = c.slug || name;
    const img = c.img || c.imageUrl || "";
    return { name, value, img };
  });
}
export const cities = [
  { name: "Mumbai", img: "https://picsum.photos/seed/mumbai/800/600" },
  { name: "Delhi", img: "https://picsum.photos/seed/delhi/800/600" },
  { name: "Bengaluru", img: "https://picsum.photos/seed/bengaluru/800/600" },
  { name: "Pune", img: "https://picsum.photos/seed/pune/800/600" },
  { name: "Hyderabad", img: "https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=1600&auto=format&fit=crop" },
];

export const testimonials = [
  {
    name: "Ritesh Gupta",
    handle: "@riteshg",
    text: "Super smooth booking and great seats. Loved the reminder and QR Ticket!",
    avatar: "https://i.pravatar.cc/80?img=12",
  },
  {
    name: "Srishti Jain",
    handle: "@srishti.j",
    text: "The app is clean and fast. Found events near me and got a sweet discount.",
    avatar: "https://i.pravatar.cc/80?img=5",
  },
  {
    name: "Sameer Patil",
    handle: "@iamsameer",
    text: "Best place to discover gigs in the city. 10/10 would recommend.",
    avatar: "https://i.pravatar.cc/80?img=33",
  },
];
